/**
 * The switch that routes one supplier's orders to the portal.
 *
 * Backed by an endpoint that writes a single flag on the supplier's config, so
 * turning this on and off never disturbs the API credentials stored next to it.
 */
define('portalUsersRoutingView',[
  'module',
  'marionette',
  'underscore',
  'app',
  'jquery',
  'template!portalUsersRoutingTpl'
], function (
  Module,
  Marionette,
  _,
  App,
  $,
  routingTpl
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    template: routingTpl,
    className: 'portal-routing-view',

    ui: {
      toggle: '.js-toggle',
      error: '.js-error',
      allowLabels: '.js-allow-labels',
      senderAddress: '.js-sender-address',
      shippingMethod: '.js-shipping-method',
      saveLabels: '.js-save-labels',
      labelsError: '.js-labels-error',
      saved: '.js-saved',
      section: '.js-section',
      sectionsError: '.js-sections-error',
      status: '.js-status',
      statusesError: '.js-statuses-error'
    },

    events: {
      'change @ui.toggle': 'onToggle',
      'change @ui.allowLabels': 'onAllowLabels',
      'click @ui.saveLabels': 'onSaveLabels',
      'change @ui.section': 'onSection',
      'change @ui.status': 'onStatus'
    },

    initialize: function (options) {
      this.supplierSecId = options.supplierSecId;
      // Sections default to on, matching the server: a supplier nobody has
      // restricted keeps everything, and an absent field must not read as "off".
      this.routing = options.routing ||
        {usePortal: false, hasApiConnector: false, allowLabels: false, sendcloudConfigured: false,
          portalOrders: true, portalProducts: true, portalTeam: true};
    },

    serializeData: function () {
      return {
        orders: this.routing.portalOrders !== false,
        products: this.routing.portalProducts !== false,
        team: this.routing.portalTeam !== false,
        usePortal: this.routing.usePortal === true,
        hasApiConnector: this.routing.hasApiConnector === true,
        allowLabels: this.routing.allowLabels === true,
        sendcloudConfigured: this.routing.sendcloudConfigured === true,
        senderAddressId: this.routing.sendcloudSenderAddressId === undefined ?
          null : this.routing.sendcloudSenderAddressId,
        shippingMethodId: this.routing.sendcloudShippingMethodId === undefined ?
          null : this.routing.sendcloudShippingMethodId
      };
    },

    /**
     * The account's order statuses, for the two selects. Fetched once per
     * view and kept: the list does not change between two clicks here.
     */
    onRender: function () {
      this.fillStatuses();
    },

    fillStatuses: function () {
      var fill = _.bind(function (statuses) {
        if (this.isDestroyed) {
          return;
        }
        this.statuses = statuses;
        this.ui.status.each(_.bind(function (i, select) {
          var $select = $(select);
          var current = this.routing[$select.data('key')] || '';
          _.each(statuses, function (status) {
            $('<option></option>').attr('value', status.statusConst).text(status.status).appendTo($select);
          });
          // A mapped code the table no longer lists is shown as it is, not
          // silently dropped to "unchanged".
          if (current && !_.findWhere(statuses, {statusConst: current})) {
            $('<option></option>').attr('value', current).text(current).appendTo($select);
          }
          $select.val(current);
        }, this));
      }, this);

      if (this.statuses) {
        fill(this.statuses);
        return;
      }
      $.when(App.request('orders:statuses', 'order'))
        .done(function (collection) {
          fill(_.map(collection && collection.models ? collection.models : (collection || []), function (model) {
            return model.toJSON ? model.toJSON() : model;
          }));
        })
        .fail(_.bind(function () {
          if (!this.isDestroyed) {
            this.ui.statusesError.text(_.i18n('portalUsers.statuses.loadFailed', null,
              'Could not read the order statuses.'));
          }
        }, this));
    },

    /** Both codes go together, as they are read: one save, one row of the config. */
    onStatus: function () {
      var mapping = {};
      this.ui.status.each(function () {
        mapping[$(this).data('key')] = $(this).val() || null;
      });

      this.ui.status.prop('disabled', true);
      this.ui.statusesError.text('');

      $.when(App.request('portal-users:set-status-mapping', this.supplierSecId, mapping))
        .done(_.bind(function (routing) {
          this.routing = routing;
          this.trigger('changed', routing);
          this.render();
        }, this))
        .fail(_.bind(function () {
          this.render();
          this.ui.statusesError.text(_.i18n('portalUsers.statuses.failed', null,
            'Could not save the statuses. Try again in a moment.'));
        }, this));
    },

    onToggle: function () {
      var enabled = this.ui.toggle.is(':checked');

      this.ui.toggle.prop('disabled', true);
      this.ui.error.text('');

      $.when(App.request('portal-users:set-routing', this.supplierSecId, enabled))
        .done(_.bind(function (routing) {
          this.routing = routing;
          this.trigger('changed', routing);
          this.render();
        }, this))
        .fail(_.bind(function () {
          // Put the switch back where it was: the config did not change, and a
          // switch showing the wrong state is worse than no switch at all.
          this.ui.toggle.prop('checked', !enabled).prop('disabled', false);
          this.ui.error.text(_.i18n('portalUsers.routing.failed', null,
            'Could not change the routing. Try again in a moment.'));
        }, this));
    },

    /**
     * The three sections are saved as a set, not one at a time: they are read as
     * a set on screen, and a partial update would let two operators each turn one
     * on and silently undo the other.
     */
    onSection: function () {
      var features = {};
      this.ui.section.each(function () {
        features[$(this).data('key')] = $(this).is(':checked');
      });

      this.ui.section.prop('disabled', true);
      this.ui.sectionsError.text('');

      $.when(App.request('portal-users:set-features', this.supplierSecId, features))
        .done(_.bind(function (routing) {
          this.routing = routing;
          this.trigger('changed', routing);
          this.render();
        }, this))
        .fail(_.bind(function () {
          // Put them back: a checkbox showing a grant the server never took is
          // worse than no checkbox at all.
          this.render();
          this.ui.sectionsError.text(_.i18n('portalUsers.sections.failed', null,
            'Could not change what this supplier can open. Try again in a moment.'));
        }, this));
    },

    /**
     * Flipping the switch saves straight away and reveals the two ids, so the
     * operator is not left wondering whether a half-filled form counts.
     */
    onAllowLabels: function () {
      this.saveLabels({
        allowLabels: this.ui.allowLabels.is(':checked'),
        sendcloudSenderAddressId: this.routing.sendcloudSenderAddressId,
        sendcloudShippingMethodId: this.routing.sendcloudShippingMethodId
      }, this.ui.allowLabels);
    },

    onSaveLabels: function () {
      this.saveLabels({
        allowLabels: true,
        sendcloudSenderAddressId: this.numberOrNull(this.ui.senderAddress.val()),
        sendcloudShippingMethodId: this.numberOrNull(this.ui.shippingMethod.val())
      }, this.ui.saveLabels);
    },

    saveLabels: function (settings, control) {
      control.prop('disabled', true);
      this.ui.labelsError.text('');
      this.ui.saved.text('');

      $.when(App.request('portal-users:set-label-settings', this.supplierSecId, settings))
        .done(_.bind(function (routing) {
          this.routing = routing;
          this.trigger('changed', routing);
          this.render();
          this.ui.saved.text(_.i18n('portalUsers.labels.saved', null, 'Saved'));
        }, this))
        .fail(_.bind(function () {
          control.prop('disabled', false);
          if (control === this.ui.allowLabels) {
            control.prop('checked', !settings.allowLabels);
          }
          this.ui.labelsError.text(_.i18n('portalUsers.labels.failed', null,
            'Could not save the label settings. Try again in a moment.'));
        }, this));
    },

    numberOrNull: function (value) {
      var trimmed = (value || '').trim();
      if (trimmed === '')
        return null;
      var parsed = parseInt(trimmed, 10);
      return isNaN(parsed) ? null : parsed;
    }
  });
});

